module.exports = __webpack_public_path__ + "img/Pengiriman.2173d63e.svg";